export const capitalizeFirstLetter = (string) =>
  string[0].toUpperCase() + string.substr(1);
